<template>

  <div class="l-page l-page--dashboard">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main--flex">
      <div class="l-main-head">


        <a ref="refAddMessageButton"  class="c-btn c-btn--blue u-w250" @click="onClickAddMessage">
          <div class="c-icon c-icon--white u-wh18 c-icon--alpha70">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#edit" />
            </svg>
          </div>
          <p class="c-btn__text">配信メッセージの作成</p>
        </a>
        <div ref="refMessageType" class="p-message-add-message-type" :class="{'is-active': isAddMessage}">
          <input type="hidden" name="_token" :value="csrfToken" />
          <div class="c-balloon">
            <div class="c-balloon__arrow"></div>
            <div class="c-balloon__close" @click.stop="onClickCloseMessageType">
              <div class="c-icon u-wh22 c-icon--gray-3">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <use xlink:href="/assets/img/sprite.svg#close-thin" />
                </svg>
              </div>
            </div>
            <div class="c-balloon-title">
              <p class="c-balloon-title__label">メッセージの種類を選択する</p>
            </div>
            <div class="c-balloon-content">
              <form autocomplete="off">
                <div class="c-radio u-w276">
                  <ul class="c-radio-list">
                    <li v-show="messageInfo.servicePlatforms.includes('2')" class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input
                          v-model="addServiceType"
                          type="radio"
                          name="add_message_type"
                          :value="messageInfo.serviceTypeValues.Browser"
                        />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">ブラウザプッシュ</div>
                        </div>
                      </label>

                      <a
                        v-if="useMessageImport"
                        href="/coins-admin/message/import/"
                        class="c-btn c-btn--blue u-w196 u-h32 u-fs--s"
                        style="width: 100px !important;
                                            position: absolute;
                                            right: -10px;
                                            top: -20px;"
                      >
                        一括登録</a>

                    </li>
                    <li v-show="messageInfo.servicePlatforms.includes('4') && useCartPush" class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input
                          v-model="addServiceType"
                          type="radio"
                          name="add_message_type"
                          :value="messageInfo.serviceTypeValues.Cart"
                        />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">カートプッシュ</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label c-text">→メッセージの作成方法は<a style="text-decoration: underline;" href="https://manual.webpush.jp/posts/create" target="_blank">こちら</a></div>
                        </div>
                      </label>
                    </li>
                  </ul>
                  <div class="c-error">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </form>
              <button
                class="c-btn c-btn--blue u-w196 u-h32 u-fs--s"
                type="submit"
                name="add_message_type"
                value="add_message_type"
                @click="onClickAddMessageContinue"
              >
                <p class="c-btn__text">メッセージ作成を進める</p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-dashboard-summary">
          <div class="c-title">
            <div class="c-title__text u-fs34">サマリー</div>
            <div class="c-date u-w620">
              <div class="c-date__title">前日より30日間データを表示しております</div>
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from"></li>
                <li class="c-date-list__item c-date-list__item--to"></li>
              </ul>
            </div>
            <div class="c-text">
              <a :href="linkData.analysisUrl">一覧で確認する</a>
            </div>
          </div>
          <div class="p-dashboard-summary__metrics">
            <div class="p-metrics-summary">
              <ul class="p-metrics-summary-list">
                <li class="p-metrics-summary-list__item is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--optin is-active">
                    <dt class="c-metrics__label">オプトイン数</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class=" c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
                <!-- 設計書 §4.1: アクティブユーザー数サマリー (集計期間はアカウント設定に従う / 画面に N 日は出さない)
                                 feature gate: sender_id 不在 (R7) または AU 機能 OFF (R7b: days=0) のとき
                                 API が active_user_count: null を返し、site-summary.js 側で is-hidden を付与してカード自体を非表示にする -->
                <li class="p-metrics-summary-list__item p-metrics-summary-list__item--active-user is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--active-user" title="集計待ち">
                    <dt class="c-metrics__label">アクティブ数</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--impression is-active">
                    <dt class="c-metrics__label">インプレッション</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--click">
                    <dt class="c-metrics__label">クリック数</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item is-loading">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--ctr">
                    <dt class="c-metrics__label">クリック率(%)</dt>
                    <dd class="c-metrics__value">-</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">-</p>
                    </dd>
                  </dl>
                </li>
              </ul>
            </div>
          </div>
          <div class="p-dashboard-summary__data is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <svg class="c-graph-line c-graph-line--summary">
              <defs>
                <clipPath id="clipPath">
                  <rect
                    x="15"
                    y="0"
                    height="330"
                    width="930"
                  />
                </clipPath>
              </defs>
              <g class="c-graph-line-frame" clip-path="url(#clipPath)">
                <rect
                  class="c-graph-line-frame__rect"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
                <line
                  class="c-graph-line-frame__line"
                  x1="15"
                  x2="945"
                  y1="330"
                  y2="330"
                />
              </g>
              <g class="c-graph-line-bg" clip-path="url(#clipPath)">
                <g class="c-graph-line-bg__x" />
                <g class="c-graph-line-bg__y" />
              </g>
              <g class="c-graph-line-chart" clip-path="url(#clipPath)" />
              <g class="c-graph-line-pointer" clip-path="url(#clipPath)">
                <rect
                  class="c-graph-line-pointer__area"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
              </g>
              <g class="c-graph-line-axis">
                <g class="c-graph-line-axis__x" />
                <g class="c-graph-line-axis__y--left" />
                <g class="c-graph-line-axis__y--right" />
              </g>
              <g class="c-graph-line-label" />
            </svg>
            <div class="c-tooltip c-tooltip--graph-line c-tooltip--summary">
              <div class="c-tooltip__title">-</div>
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--optin">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--delivery">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--impression">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--click">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--ctr is-active">-</li>
                <!-- 設計書 §4.1: AU 系列のツールチップ。
                                 graph-line.js の showTooltip 側で active-user (hyphen) → activeUser (camel) に変換してデータ参照 -->
                <li class="c-tooltip-list__item c-tooltip-list__item--active-user">-</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="l-main-content">
        <div class="p-analysis-all-summary-optin">
          <div class="c-title">
            <div class="c-title__text u-fs34">オプトイン数推移</div>
            <div class="c-date u-w620">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from"></li>
                <li class="c-date-list__item c-date-list__item--to"></li>
              </ul>
            </div>
          </div>
          <div class="p-analysis-all-summary-optin__data is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <svg class="c-graph-line c-graph-line--summary-optin">
              <defs>
                <clipPath id="clipPathSummaryOptin">
                  <rect
                    x="15"
                    y="0"
                    height="330"
                    width="930"
                  />
                </clipPath>
              </defs>
              <g class="c-graph-line-frame" clip-path="url(#clipPathSummaryOptin)">
                <rect
                  class="c-graph-line-frame__rect"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
                <line
                  class="c-graph-line-frame__line"
                  x1="15"
                  x2="945"
                  y1="330"
                  y2="330"
                />
              </g>
              <g class="c-graph-line-bg" clip-path="url(#clipPathSummaryOptin)">
                <g class="c-graph-line-bg__x" />
                <g class="c-graph-line-bg__y" />
              </g>
              <g class="c-graph-line-chart" clip-path="url(#clipPathSummaryOptin)" />
              <g class="c-graph-line-pointer" clip-path="url(#clipPathSummaryOptin)">
                <rect
                  class="c-graph-line-pointer__area"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
              </g>
              <g class="c-graph-line-axis">
                <g class="c-graph-line-axis__x" />
                <g class="c-graph-line-axis__y--left" />
                <g class="c-graph-line-axis__y--right" />
              </g>
              <g class="c-graph-line-label" />
            </svg>
            <div class="c-tooltip c-tooltip--graph-line c-tooltip--summary-optin">
              <div class="c-tooltip__title">-</div>
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--optin">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--delivery">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--impression">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--click">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--ctr is-active">-</li>
                <!-- 設計書 §4.2: オプトイン推移グラフ tooltip にアクティブユーザー数を追加 -->
                <li class="c-tooltip-list__item c-tooltip-list__item--active-user">-</li>
              </ul>
            </div>

          </div>
          <div class="p-analysis-all-summary-optin__data-table is-loading">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--summary-optin-page">
              <thead>
                <tr>
                  <th class="c-table__cell--center is-sortable">
                    <span class="c-table__text">許可されたページ</span>
                    <span class="c-btn c-btn--sort" data-type="page"></span>
                  </th>
                  <th class="c-table__cell--center u-w320 is-sortable">
                    <span class="c-table__text">許可数</span>
                    <span class="c-btn c-btn--sort c-btn--sort-desc" data-type="grantedCount"></span>
                  </th>
                  <th class="c-table__cell--center u-w320 is-sortable">
                    <span class="c-table__text">許可率</span>
                    <span class="c-btn c-btn--sort c-btn--sort-desc" data-type="optinRate"></span>
                  </th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>


      <div class="l-main-content l-main-content--delivery">
        <div class="p-dashboard-delivery is-loading">
          <div class="c-title">
            <div class="c-title__text">
              最近の配信状況
            </div>
            <div class="c-proposal">
              <div class="c-proposal__text">最新の配信状況<span class="c-proposal__value">-</span>件を表示しております</div>
            </div>
            <div class="c-text"><a :href="linkData.analysisUrl">詳細を見る</a></div>
          </div>
          <div class="p-dashboard-delivery__data">
            <div class="c-loader"></div>
            <div class="p-dashboard-delivery__data-head">
              <table class="c-table">
                <thead>
                  <tr>
                    <th class="c-table__cell--center u-w110 is-sortable"><span
                      class="c-table__text"
                    >配信日</span><span
                      class="c-btn c-btn--sort c-btn--sort-desc"
                      data-type="deliveryDate"
                    ></span>
                    </th>
                    <th class="c-table__cell--center u-w110 is-sortable"><span
                      class="c-table__text"
                    >集計日</span><span
                      class="c-btn c-btn--sort"
                      data-type="summaryDate"
                    ></span></th>
                    <th class="c-table__cell--center u-w600 is-sortable"><span
                      class="c-table__text"
                    >タイトル・メッセージ</span><span
                      class="c-btn c-btn--sort"
                      data-type="title"
                    ></span></th>
                    <th class="c-table__cell--center u-w110 is-sortable"><span
                      class="c-table__text"
                    >クリック数</span><span
                      class="c-btn c-btn--sort"
                      data-type="click"
                    ></span></th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="p-dashboard-delivery__data-body">
              <div class="c-empty">
                <div class="c-empty__text">配信後にデータが反映されます</div>
              </div>
              <div class="p-dashboard-delivery__data-body-inner">
                <table class="c-table">
                  <tbody></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content l-main-content--half">
        <div class="p-dashboard-timezone">
          <div class="c-title">
            <div class="c-title__text">曜日と時間での結果</div>
            <div class="c-text">
              <a href="/coins-admin/analysis/delivery-timezone">詳細を見る</a>
            </div>
          </div>
          <div class="c-tab c-tab--analysis c-tab--device">
            <ul class="c-tab-list">
              <li class="c-tab-list__item is-active" data-type="delivery">配信対象</li>
              <li class="c-tab-list__item" data-type="impression">インプレッション</li>
              <li class="c-tab-list__item" data-type="click">クリック数</li>
              <li class="c-tab-list__item" data-type="ctr">クリック率</li>
            </ul>
          </div>
          <div class="p-dashboard-timezone__data is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="c-graph-heatmap-timezone">
              <div class="c-graph-heatmap-timezone__row">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">月</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">火</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">水</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">木</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">金</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">土</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">日</div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="0_3">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  0〜3時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-0_3">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-0_3">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="3_6">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  3〜6時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-3_6">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-3_6">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="6_9">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  6〜9時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-6_9">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-6_9">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="9_12">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  9〜12時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-9_12">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-9_12">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="12_15">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  12〜15時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-12_15">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-12_15">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="15_18">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  15〜18時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-15_18">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-15_18">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="18_21">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  18〜21時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-18_21">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-18_21">
                </div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="21_24">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  21〜24時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-21_24">
                </div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-21_24">
                </div>
              </div>
            </div>
            <ul class="c-graph-heatmap-timezone-bar">
              <li class="c-graph-heatmap-timezone-bar__item"><span></span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r1">
                <span>-</span>
              </li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r2">
                <span>-</span>
              </li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r3">
                <span>-</span>
              </li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r4">
                <span>-</span>
              </li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r5">
                <span>-</span>
              </li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r6">
                <span>-</span>
              </li>
            </ul>
            <ul class="c-graph-heatmap-timezone-bar-label-x">
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
            </ul>

          </div>
        </div>
      </div>
      <div class="l-main-content l-main-content--half">
        <div class="p-dashboard-device">
          <div class="c-title">
            <div class="c-title__text">デバイス</div>
            <div class="c-text">
              <a :href="linkData.deviceUrl">詳細を見る</a>
            </div>
          </div>
          <div class="c-tab c-tab--analysis c-tab--device">
            <ul class="c-tab-list">
              <li class="c-tab-list__item is-active" data-type="delivery">配信対象</li>
              <li class="c-tab-list__item" data-type="impression">インプレッション</li>
              <li class="c-tab-list__item" data-type="click">クリック数</li>
              <li class="c-tab-list__item" data-type="ctr">クリック率</li>
            </ul>
          </div>
          <div class="p-dashboard-device__data is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <svg class="c-graph-donuts c-graph-donuts--device">
              <g class="c-graph-donuts__chart" />
              <g class="c-graph-donuts__values" />
              <g class="c-graph-donuts__title" />
              <g class="c-graph-donuts__labels" />
            </svg>
            <div class="c-tooltip c-tooltip--graph-donuts c-tooltip--device">
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--desktop is-active">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--mobile is-active">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--tablet is-active">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--other is-active">-</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-dashboard-custom-attr">
          <div class="c-title">
            <div class="c-title__text">ユーザーの変化</div>
          </div>
          <div class="p-dashboard-custom-attr__data is-loading">
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="c-graph-meter c-graph-meter--male">
              <div class="c-graph-meter__label">過去30日以内に登録されたユーザー（単位）</div>
              <div class="c-graph-meter-summary">
                <div class="c-graph-meter-summary__total">00,000</div>
                <div class="c-graph-meter-summary__per">全体00%</div>
              </div>
              <ul class="c-graph-meter-list">
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
              </ul>
            </div>
            <div class="c-graph-meter c-graph-meter--male">
              <div class="c-graph-meter__label">アクティブ（30日以内）のユーザー（単位）</div>
              <div class="c-graph-meter-summary">
                <div class="c-graph-meter-summary__total">00,000</div>
                <div class="c-graph-meter-summary__per">全体00%</div>
              </div>
              <ul class="c-graph-meter-list">
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
                <li class="c-graph-meter-list__item c-graph-meter-list__item--empty"></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />

    <error-modal
      ref="refPermissionErrorModal"
      :message="permissionErrorMessage"
      :is-active="isPermissionError"
      :on-close-click="onClosePermissionErrorModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
import store from "../../funcs/store.js";
export default {
  props: {
    breadcrumbData: Array,
    linkData: Object,
    messageInfo: Object,
    csrfToken: String,
  },
  data () {
    return {
      isError: false,
      errorMessage: '',
      addServiceType: null,
      isAddMessage: false,
      isPermissionError: false,
      isPermissionCheckProcessing: false,
      permissionErrorMessage: ''
    }
  },
  computed: {
    useCartPush: function() {
      return store.getResourceAccessRules()['CART_PUSH'];
    },
    useMessageImport: function() {
      return store.getResourceAccessRules()['MESSAGE_IMPORT'];
    },
  },
  mounted: function() {
    import('../../funcs/pages/dashboard').then(module => {
      module.Dashboard();
    });
  },
  methods: {
    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 配信メッセージの作成ボタン
    onClickAddMessage: function() {
      this.isAddMessage = !this.isAddMessage;
    },

    // 新規作成ボタンクリック
    onClickAddMessageContinue: function() {
      if(!this.addServiceType){
        this.isError = true;
        this.errorMessage = 'メッセージの種類を選択してください'
      } else {
        // パーミッションチェック
        let url = this.messageInfo.addUrl + '?type=new&service_type=' + this.addServiceType;
        if (this.isPermissionCheckProcessing) {
          return;
        }
        this.isPermissionCheckProcessing = true;
        axios.get('/api/permissions/url-access?path=' + encodeURIComponent(url))
          .then((res) => {
            this.isPermissionCheckProcessing = false;
            if (res.data.status === 'OK') {
              location.href = url;
            } else {
              this.isPermissionError = true;
              this.permissionErrorMessage = res.data.message;
            }
          })
          .catch(_error => {
            this.isPermissionCheckProcessing = false;
            this.isPermissionError = true;
            this.permissionErrorMessage = "エラーが発生しました。";
          });
      }
    },

    // クリック: メッセージタイプ選択エリアの閉じるボタン
    onClickCloseMessageType: function() {
      this.isAddMessage = false;
    },

    // クリック: メッセージタイプ選択エリアの範囲外
    onClickCloseMessageTypeOuter: function(event) {
      // メッセージ作成ボタンかメッセージタイプ選択エリアのクリックの場合は処理終了
      if (this.$refs.refAddMessageButton.contains(event.target) || this.$refs.refMessageType.contains(event.target)) return;
      this.isAddMessage = false;
    },
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },

    onClosePermissionErrorModal() {
      this.isPermissionError = false;
    },
  }
}
</script>
